<template>
  <div class="page" ref="wrapObj">
    <!--ヘッダーここから-->
    <QuestionHeader
      :config="config"
      @open="
        (e) => {
          $refs[e].show();
        }
      "
      @hide="
        (e) => {
          $refs[e].hide();
        }
      "
      @setConfig="setConfig"
      @home="home"
    />
    <!--ヘッダここまでー-->
    <div class="wrap">
      <!--結果コメントとスコア表示-->
      <div class="res-top-container">
        <div class="res-sakura-box">
          <img
            src="@/assets/img/chatarou_1.png"
            class="animated fadeIn res-chatarou"
            alt="チャ太郎"
          />
          <img
            v-if="percent >= 0.2"
            src="@/assets/img/sakura_full.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku1"
          />
          <img
            v-else-if="percent >= 0.1"
            src="@/assets/img/sakura_half.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku1"
          />
          <img
            v-else
            src="@/assets/img/sakura_none.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku1"
          />

          <img
            v-if="percent >= 0.4"
            src="@/assets/img/sakura_full.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku2"
          />
          <img
            v-else-if="percent >= 0.3"
            src="@/assets/img/sakura_half.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku2"
          />
          <img
            v-else
            src="@/assets/img/sakura_none.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku2"
          />

          <img
            v-if="percent >= 0.6"
            src="@/assets/img/sakura_full.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku3"
          />
          <img
            v-else-if="percent >= 0.5"
            src="@/assets/img/sakura_half.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku3"
          />
          <img
            v-else
            src="@/assets/img/sakura_none.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku3"
          />

          <img
            v-if="percent >= 0.8"
            src="@/assets/img/sakura_full.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku4"
          />
          <img
            v-else-if="percent >= 0.7"
            src="@/assets/img/sakura_half.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku4"
          />
          <img
            v-else
            src="@/assets/img/sakura_none.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku4"
          />

          <img
            v-if="percent >= 1"
            src="@/assets/img/sakura_full.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku5"
          />
          <img
            v-else-if="percent >= 0.9"
            src="@/assets/img/sakura_half.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku5"
          />
          <img
            v-else
            src="@/assets/img/sakura_none.png"
            class="res-sakura animated zoomIn"
            alt
            id="res_saku5"
          />
        </div>
        <div class="res-comment-box animated bounceInRight">
          <div class="res-score">
            <span>{{ sortedHistory.length }}</span
            >問中 <span id="user-sco">{{ correctAnswers.length }}</span
            >問正解
          </div>
          <div class="res-comment">{{ comment }}</div>
        </div>
      </div>
      <!--問題のリスト-->
      <div class="container col_2" id="res-list-container">
        <div
          class="res-list"
          :id="`res-${idx}`"
          v-for="(h, idx) in sortedHistory"
          :key="`res-${idx}`"
          @click="qidx = idx"
        >
          第
          <span style="display: inline-block; width: 2em; text-align: center">{{
            idx + 1
          }}</span>
          問
          <img
            v-if="h.tof"
            src="@/assets/img/maru.png"
            class="res-list-icon"
            alt="正解"
          />
          <img
            v-else
            src="@/assets/img/batsu.png"
            class="res-list-icon"
            alt="不正解"
          />
          <img src="@/assets/img/icon_arrow.png" class="icon-arrow" />
        </div>
      </div>
      <ol class="btn-start">
        <li @click="goIndex">&nbsp;TOP画面へ</li>
      </ol>
      <div
        class="mo-wrap"
        :style="{ height: wrap ? `${wrap}px` : '100%' }"
        v-if="qidx !== null"
      >
        <div class="mo-win">
          <span
            @click="qidx = null"
            aria-hidden="true"
            class="btn-close res-select-btn"
            >×</span
          >
          <div style="height: 2.5rem"></div>
          <QuestionPage
            :gap="gap"
            :wrap="wrap"
          />
        </div>
      </div>
    </div>

    
    <!-- モーダル ここから -->
    <b-modal
      id="modal-top"
      ref="modal-top"
      centered
      @show="pauseTimer"
      @hidden="resumeTimer"
    >
      <template v-slot:modal-header>
        <button
          type="button"
          class="close"
          @click.prevent="$refs['modal-top'].hide()"
          @touchend.prevent="$refs['modal-top'].hide()"
          aria-label="Close"
        >
          <span aria-hidden="true" class="btn-close">&times;</span>
        </button>
      </template>
      <b-container fluid>TOP画面に戻りますか？</b-container>
      <template v-slot:modal-footer>
        <button
          type="button"
          class="btn btn-secondary btn-modal"
          @click.prevent="$refs['modal-top'].hide()"
          @touchend.prevent="$refs['modal-top'].hide()"
        >
          いいえ
        </button>
        <button
          type="button"
          @click.prevent="goIndex"
          @touchend.prevent="goIndex"
          class="btn btn-modal-yes btn-modal"
        >
          はい
        </button>
      </template>
    </b-modal>
    <!-- モーダル ここまで -->
  </div>
</template>

<script>
/* eslint-disable no-console */
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import QuestionPage from "@/components/questionPages/Question/Index.vue";
import QuestionHeader from "@/components/parts/QuestionHeader.vue";

import setConfig from "@/components/setConfig";

export default {
  name: "QuestionList",
  components: {
    QuestionHeader,
    QuestionPage
  },
  props: {
    orderList: Array,
    selectedList: Array,

    lastQuestions: Array,

    gap: Number,
    wrap: Number
  },
  data() {
    return {
      swiperOption: {
        // some swiper options/callbacks
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      mode: "start",
      now: 0,
      selected: null,
      public: process.env.BASE_URL,
      circleNum: ["①", "②", "③", "④"],
      sent: false,
      qidx: null
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  computed: {
    drills() {
      return this.$store.state.drills;
    },
    drill() {
      return this.$store.getters.drill;
    },
    setting() {
      return this.$store.state.setting;
    },
    config() {
      return this.$store.state.config;
    },
    question() {
      return this.$store.getters.question;
    },
    history() {
      return this.$store.getters.questionHistory.data;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    title() {
      if (this.setting) {
        return this.setting.title.split("\n").join("<br>");
      }
      return null;
    },
    sortedHistory() {
      const history = this.history;
      return history.sort((a, b) => {
        return a.listNo < b.listNo ? -1 : 1;
      });
    },
    lastPercent() {
      if (!this.lastQuestions) {
        return 1;
      }
      const correctAnswers = this.lastQuestions.filter(e => e === true).length;
      const allQuestions = this.lastQuestions.length;
      return correctAnswers / allQuestions;
    },
    percent() {
      return this.correctAnswers.length / this.sortedHistory.length;
    },
    comment() {
      if (this.lastPercent < this.percent) {
        return "成績アップだ！";
      }

      if (this.percent < 0.5) {
        return "次はがんばろう！";
      } else if (this.percent < 0.8) {
        return "がんばったね！";
      } else if (this.percent < 1) {
        return "よくできました！";
      }
      return "すごいすごい！";
    },

    qComment() {
      return this.nowQuestion.comment;
    },

    nowQuestion() {
      return this.question.questions[this.qidx];
    },
    correctAnswers() {
      return this.history.filter(el => el.tof === true);
    }
  },
  methods: {
    home() {
      this.$store.commit("home");
    },
    goIndex() {
      const drillId = String(this.$store.state.drillId)
      this.$store.commit("home");
      setTimeout(() => {
              this.$store.commit("startQuestion", drillId);
      }, 20)
    },
    setConfig,
  },
  watch: {
    qidx(nv) {
      if (nv == null) {
        this.$store.commit("setModal", false);
      } else {
        this.$store.commit("changeQuestion", nv);
        this.$store.commit("setModal", true);
        // this.commentInit();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

.wrap {
  width: 100%;
  height: 100%;
  position: relative;
}

.swipe-box {
  width: calc(100% - 88px);
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
}

.mo-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.25);

  display: flex;
  justify-content: center;
  align-items: center;
}

.mo-win {
  background-color: #fff;
  width: 95%;
  height: 90%;
  overflow: hidden;
  border-radius: 10px;
}

.play-title {
  background-color: #ffffff;
  color: #000000;
  padding: 0.25rem 1rem;
  margin: 0 auto;
  width: 96%;
  font-size: 1.15em;
  border-radius: 10px;
  margin-top: -15px;
  position: relative;
  top: 90px;
}

.play-title-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.results-mark {
  flex: 0 0 5rem;
  text-align: right;
  line-height: 24px;
}

.results-mark img {
  height: 24px;
}

#q-title {
  display: flex;
  margin: 0;

  justify-content: space-between;
}
</style>
